import { action, toJS } from 'mobx';
import SentryService from './SentryService';

export class AppStorage {
  static default = new AppStorage();

  constructor(readonly namespace: string = 'default') {}

  // multiSet(data: Map<string, any>): Promise<any> {
  //   const jsonData = Array.from(data.entries()).map(([key, entry]) =>
  //     this.namespace ? [`${this.namespace}_${key}`, this.normalize(entry)] : [key, this.normalize(entry)],
  //   );
  //   const eraseKeys = jsonData.filter(([, entry]) => !entry).map(([key]) => key) as string[];
  //   const saveData = jsonData.filter(([, entry]) => !!entry) as [string, string][];
  //
  //   if (eraseKeys.length > 0 && saveData.length > 0) {
  //     return Promise.all([AsyncStorage.multiSet(saveData), AsyncStorage.multiRemove(eraseKeys)]);
  //   } else if (eraseKeys.length > 0) {
  //     return AsyncStorage.multiRemove(eraseKeys);
  //   } else if (saveData.length > 0) {
  //     return AsyncStorage.multiSet(saveData);
  //   }
  //   return Promise.resolve();
  // }

  @action
  setObject<T>(key: string, data: T, ttl: number = -1): Promise<T> {
    // try {
    //   const object = this.normalize(data);
    //   if (object) {
    //     return this.mmkv.setMapAsync(key, object).then(() => data);
    //   }
    //   this.mmkv.removeItem(key);
    //   return Promise.resolve(data);
    // } catch (e: any) {
    //   SentryService.captureException(e);
    // }

    return Promise.resolve(data);
  }

  // setInt(key: string, data: number, ttl: number = -1): Promise<boolean> {
  //   return this.mmkv.setIntAsync(key, data).then((res) => res ?? false);
  // }
  //
  // setString(key: string, data: string, ttl: number = -1): Promise<boolean> {
  //   return this.mmkv.setStringAsync(key, data).then((res) => res ?? false);
  // }
  //
  // setBool(key: string, data: boolean, ttl: number = -1): Promise<boolean> {
  //   return this.mmkv.setBoolAsync(key, data).then((res) => res ?? false);
  // }
  //
  // setArray(key: string, data: any[], ttl: number = -1): Promise<boolean> {
  //   return this.mmkv.setArrayAsync(key, data).then((res) => res ?? false);
  // }

  // async push<T>(key: string, data: T): Promise<T> {
  //   try {
  //     const entry = this.clean(data);
  //     if (entry) {
  //       const array = await this.get(key);
  //       if (Array.isArray(array)) {
  //         array.push(entry);
  //         return this.store(key, array)
  //           .then(() => data)
  //           .catch(() => data);
  //       }
  //       return this.store(key, [entry])
  //         .then(() => data)
  //         .catch(() => data);
  //     }
  //   } catch (e) {}
  //
  //   return Promise.resolve(data);
  // }

  // getObject(key: string): Promise<any | null | undefined> {
  //   return this.mmkv.getMapAsync(key);
  // }
  //
  // getArray<T>(key: string): Promise<T[] | null | undefined> {
  //   return this.mmkv.getArrayAsync<T>(key);
  // }
  //
  // getString(key: string): Promise<string | null | undefined> {
  //   return this.mmkv.getStringAsync(key);
  // }
  //
  // getInt(key: string): Promise<number | null | undefined> {
  //   return this.mmkv.getIntAsync(key);
  // }
  //
  // get(key: string): Promise<any | null | undefined> {
  //   return this.getObject(key).catch((e) => {
  //     SentryService.captureException(e);
  //     return undefined;
  //   });
  // }
  //
  // @action
  // delete(key: string): Promise<boolean> {
  //   return Promise.resolve(this.mmkv.removeItem(key) ?? false);
  // }
  //
  // @action
  // multiRemove(keys: string[]): Promise<void> {
  //   if (keys.length > 0) {
  //     return Promise.all(keys.map((key) => this.delete(key))).then(() => Promise.resolve());
  //   }
  //   return Promise.resolve();
  // }

  // load(): Promise<any> {
  //   return this.getAllKeys()
  //     .then((keys) => AsyncStorage.multiGet(keys))
  //     .then((results) =>
  //       results.reduce((result: any, [key, value]) => {
  //         const cleanKey = this.namespace ? key.replace(`${this.namespace}_`, '') : key;
  //         try {
  //           if (value) {
  //             result[cleanKey] = JSON.parse(value);
  //           } else {
  //             result[cleanKey] = undefined;
  //           }
  //         } catch (e) {
  //           logger(`Unable to parse ${cleanKey}`);
  //           result[cleanKey] = undefined;
  //         }
  //         return result;
  //       }, {}),
  //     )
  //     .then((data) => {
  //       runInAction(() => (this.data = observable.map({})));
  //       return data;
  //     })
  //     .catch((err) => {
  //       logger('loading error', err);
  //       return {};
  //     });
  // }

  @action
  clear(): Promise<boolean> {
    // this.mmkv.clearMemoryCache();
    // return Promise.resolve(this.mmkv.clearStore() ?? false);
    return Promise.resolve(false);
  }

  // private clean(data: any): any | undefined {
  //   if (data) {
  //     return toJS(data);
  //     // return data.toJS instanceof Function ? data : toJS(data);
  //   }
  //   return undefined;
  // }
  //
  // private normalize(data: any): any | undefined {
  //   if (data) {
  //     return this.clean(data);
  //   }
  //   return undefined;
  // }
}
